/**
 * WOOF Quantity Breaks
 * Selecting a tier stores the number of pendants as a private line property.
 * The necklace itself remains quantity one; paid extra pendants are added by
 * WOOF Pet Form as nested add-on lines.
 */
class WoofQuantityBreaks extends HTMLElement {
  connectedCallback() {
    this.radios = [...this.querySelectorAll('[data-tier]')];
    this.current = this.querySelector('[data-current-quantity]');
    this.countInput = this.querySelector('[data-pendant-count]');
    if (!this.radios.length) return;

    this.radios.forEach((radio) => radio.addEventListener('change', () => this.#applyCount()));

    if (this.hasAttribute('data-hide-quantity')) {
      this.#quantityInput()?.closest('.quantity-selector-wrapper')?.style.setProperty('display', 'none');
    }

    // Sync the form with the pre-selected tier on load
    this.#applyCount();
  }

  #quantityInput() {
    const form = document.getElementById(this.dataset.formId || '');
    if (!form) return null;
    const element = form.elements.namedItem('quantity');
    return element instanceof HTMLInputElement ? element : null;
  }

  #applyCount() {
    const selected = this.radios.find((radio) => radio.checked);
    if (!selected || !(this.countInput instanceof HTMLInputElement)) return;
    if (this.current) this.current.textContent = selected.value;
    this.countInput.value = selected.value;
    const quantityInput = this.#quantityInput();
    if (quantityInput) {
      // Pendant count is configuration data, never the necklace line quantity.
      // Horizon can restore an existing cart quantity while its selector is
      // hidden, so reset both the current and reset values defensively.
      quantityInput.value = '1';
      quantityInput.defaultValue = '1';
    }
    const form = document.getElementById(this.dataset.formId || '');
    form?.dispatchEvent(
      new CustomEvent('woof:pendant-count-change', {
        detail: { count: Number(selected.value) || 1 },
      })
    );
  }
}

if (!customElements.get('woof-quantity-breaks')) {
  customElements.define('woof-quantity-breaks', WoofQuantityBreaks);
}
